import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./state/AuthContext";
import { BudgetSocketProvider } from "./state/BudgetSocketContext";
import "./styles.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HashRouter>
      <AuthProvider>
        <BudgetSocketProvider>
          <App />
        </BudgetSocketProvider>
      </AuthProvider>
    </HashRouter>
  </React.StrictMode>,
);
